import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { QuoteStatusResponse } from '../models/quote-status.model';

@Injectable({
  providedIn: 'root'
})
export class QuoteStatusApiService {
  private readonly apiUrl = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) { }

  // GET /api/quote-statuses - List all quote statuses
  getAllStatuses(): Observable<QuoteStatusResponse[]> {
    return this.http.get<QuoteStatusResponse[]>(`${this.apiUrl}/quote-statuses`);
  }

  // GET /api/quote-statuses/{id} - Get quote status by ID
  getStatusById(id: number): Observable<QuoteStatusResponse> {
    return this.http.get<QuoteStatusResponse>(`${this.apiUrl}/quote-statuses/${id}`);
  }
}
